<style src="@/assets/styles/components/modules/checkout/thankyou.styl" lang="stylus" scoped></style>
<template src="@/components/collections/templates/ThankyouTemplate.html"></template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import ThankyouMixin from "@/mixins/thank-you-mixin"
export default {
  mixins: [ThankyouMixin],
  data() {
    return {
      goto_app: true
    }
  },
  methods: {
    close() {
      this.$store.dispatch('reset_unpaid_invoices');
      this.$store.dispatch('set_modal', false);
      this.$router.replace({
        name: "main"
      });
    }
  }
}
</script>
